import styled from "@emotion/styled";
import { MDSLogo, MDSText } from "@/mds";

export const Wrapper = styled.div``;

export const SessionTitle = styled(MDSText)<{ $isCollapsed?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: ${({ theme }) => theme.fontSizes["header-s"]};
  line-height: ${({ theme }) => theme.lineHeights["header-s"]};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  color: ${({ theme }) => theme.colors.text.contrast};
  padding-left: ${({ theme }) => theme.spacing[3]};
  padding-right: ${({ theme }) => theme.spacing[1]};
  margin: 0;
  cursor: ${({ $isCollapsed }) => ($isCollapsed ? "pointer" : "default")};
`;

export const TitleAndStatusContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const SessionBody = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing[2]};
  padding-block: ${({ theme }) => theme.spacing[3]};
  padding-inline: ${({ theme }) => theme.spacing[2]};
`;

export const MessagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 1px;
`;

export const ReasoningGroup = styled.div`
  padding-top: 1px;
  padding-bottom: ${({ theme }) => theme.spacing[1]};
`;

export const ReasoningHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  line-height: ${({ theme }) => theme.lineHeights["text-xs"]};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  margin-bottom: ${({ theme }) => theme.spacing[1]};

  &:hover {
    text-decoration: underline;
  }

  .mds-icon {
    color: ${({ theme }) => theme.colors.text.secondary};
    font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
    width: ${({ theme }) => theme.fontSizes["text-xs"]};
    height: ${({ theme }) => theme.fontSizes["text-xs"]};
  }
`;

export const Icon = styled(MDSLogo)`
  width: 20px;
  height: 20px;
`;

export const DebugContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["2"]};

  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  color: ${({ theme }) => theme.colors.text.tertiary};
  cursor: pointer;
`;

export const DebugSessionId = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: ${({ theme }) => theme.spacing["2"]};
  padding-right: ${({ theme }) => theme.spacing["2"]};
  border-radius: ${({ theme }) => theme.borderRadius.medium};

  &:active {
    color: ${({ theme }) => theme.colors.text.tertiary};
    background-color: ${({ theme }) => theme.colors.background.button.chip.default};
  }
`;

export const DismissLink = styled.a`
  color: ${({ theme }) => theme.colors.text.link.default};
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};

  &:hover {
    text-decoration: underline;
  }
`;
